import React, { useState, useEffect } from 'react';
import './Notification.scss';
import './bothcss.scss'

import axios from 'axios';
import { RiCalendar2Line, RiMenuLine, RiSearchLine } from "react-icons/ri";
import { MdOutlineWatchLater } from "react-icons/md";

function Notification() {
  const [searchQuery, setSearchQuery] = useState('');
  const [notifications, setNotifications] = useState([]);
  const [filteredNotifications, setFilteredNotifications] = useState([]);
  const [isSearching, setIsSearching] = useState(false);

  const API_URL = "https://ridehire-backend-2.onrender.com/host/blockOut-event";

  useEffect(() => {
    fetchNotificationData();
  }, []);

  const fetchNotificationData = async () => {
    try {
      const response = await axios.get(API_URL);
      console.log("API Response:", response.data.events);
      setNotifications(response.data.events || []);
      setFilteredNotifications(response.data.events || []);
    } catch (error) {
      console.error("Error fetching notification data:", error);
    }
  };

  const handleSearchChange = (e) => {
    const query = e.target.value;
    setSearchQuery(query);

    if (query.length >= 2) {
      setIsSearching(true);
      const timeout = setTimeout(() => {
        filterNotifications(query);
      }, 300); // Trigger search after 300ms
      return () => clearTimeout(timeout);
    } else {
      setIsSearching(false);
      setFilteredNotifications(notifications); // Show all notifications when search query is cleared
    }
  };

  const filterNotifications = (query) => {
    const filtered = notifications.filter(notification =>
      notification.bus_name?.toLowerCase().includes(query.toLowerCase()) ||
      notification.event_name?.toLowerCase().includes(query.toLowerCase())
    );
    setFilteredNotifications(filtered);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const options = { year: 'numeric', month: 'short', day: 'numeric' };  // Change 'month: 'long'' to 'short' for shorter month names
    const formattedDate = date.toLocaleDateString('en-US', options);
    const dayOfWeek = date.toLocaleDateString('en-US', { weekday: 'long' }); // Ensure weekday is 'long' (e.g., 'Thursday')
    return `${formattedDate}, ${dayOfWeek}`; // Result: "8 Dec 2021, Thursday"
  };

  const groupEventsByDate = (events) => {
    const grouped = events.reduce((groups, notification) => {
      const date = formatDate(notification.departureStartTime);
      if (!groups[date]) {
        groups[date] = [];
      }
      groups[date].push(notification);
      return groups;
    }, {});
    return grouped;
  };

  const groupedNotifications = groupEventsByDate(filteredNotifications);

  const formatTimeRange = (startTime, endTime) => {
    const formatTime = (timeString) => {
      const date = new Date(timeString);
      return date.toLocaleTimeString('en-US', {
        hour: 'numeric',
        minute: '2-digit',
        hour12: true
      }).toLowerCase();
    };
    return `${formatTime(startTime)} - ${formatTime(endTime)}`;
  };

  return (
    <div className="notification-container">
      <div className="search-bar  ">
        <div className="search-input-container">
          <RiSearchLine className="search-icon" />
          <input
            type="text"
            value={searchQuery}
            onChange={handleSearchChange}
            placeholder="Search by Bus Name"
          />
          <RiMenuLine className="menu-icon" />
        </div>
      </div>

      <div className="notification m-0 w-100">
        <ul className='m-0 p-0 list-unstyled'>
          {Object.keys(groupedNotifications).length > 0 ? (
            Object.keys(groupedNotifications).map((date, index) => (
              <div key={index}>
                <p className="date-title m-0 mt-3">{date}</p>
                {groupedNotifications[date].map((notification, idx) => (
                  <li key={idx} className={` ${isSearching ? 'slide-up' : ''}`}>
                    <div className="notification-box mt-2 p-2">
                      <div className="d-flex">
                        <div className="content">
                          <div className="d-flex justify-content-between">
                            <div className="name-rupees d-flex ">
                              <p className='m-0 price-txt me-1'>{notification.total_price || '$0'}</p> &nbsp;
                              <div className="d-xl-block d-none">
                                <div className="d-flex ">
                                  <img 
                                    src={notification.event_img ? `https://ridehire-backend-2.onrender.com${notification.event_img}` : "https://via.placeholder.com/50"} 
                                    className='notification-img' 
                                    alt="Event" 
                                  />
                                  <p className='m-0 ms-1'>{notification.driver_name || 'Unknown Driver'}</p>
                                </div>
                              </div>
                            </div>
                            <div className="id">{notification.event_id || 'N/A'}</div>
                          </div>

                          <div className="name-logo d-flex d-xl-none d-block">
                            <img 
                              src={notification.event_img ? `https://ridehire-backend-2.onrender.com${notification.event_img}` : "https://via.placeholder.com/50"} 
                              className='notification-img' 
                              alt="Event" 
                            />
                            <p className='m-0 ms-1'>{notification.driver_name || 'Unknown Driver'}</p>
                          </div>

                          <div className="d-flex">
                            <p className='passenger m-0 pt-2'>{notification.passenger_Total_Size || 0} passenger&nbsp; {notification.bus_name || 'Unknown Bus'}</p>
                          </div>

                          <div className="d-xl-flex w-100 d-column align-items-baseline">
                            <div className="d-flex align-items-center">
                              <RiCalendar2Line className='calendar-icon me-1' />
                              <p className='m-0 date me-1'>{formatDate(notification.departureStartTime)}</p>
                            </div>
                            <div className="d-flex align-items-center">
                              <MdOutlineWatchLater className='watch-icon h-100 me-1' />
                              <p className='m-0 time'>{formatTimeRange(notification.departureStartTime, notification.departureEndTime)}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                ))}
              </div>
            ))
          ) : (
            <p>No events found</p>
          )}
        </ul>
      </div>
    </div>
  );
}

export default Notification;
